import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL, STORE } from "@/config/site";
import Footer from "@/components/Footer";

export default function LegalPage({ title, lastUpdated, children, testId }) {
  return (
    <div data-testid={testId} className="bg-brand-bg min-h-screen text-white">
      <header className="bg-[#0A0A0A] border-b border-white/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="legal-back-link">
            <img src={LOGO_URL} alt="Smashed Burger & Bao Boy" className="h-12 w-auto" />
            <span className="font-subheading font-semibold uppercase tracking-widest text-xs text-white/70 hidden sm:inline-flex items-center gap-1">
              <ArrowLeft size={14} /> Back to site
            </span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <span className="inline-block font-subheading font-bold uppercase tracking-[0.3em] text-brand-orange text-xs mb-4">
          Legal
        </span>
        <h1 className="font-heading text-5xl sm:text-7xl uppercase leading-none tracking-tight">{title}</h1>
        <p className="mt-4 font-body text-white/55 text-sm">Last updated: {lastUpdated}</p>

        <div className="prose prose-invert mt-10 max-w-none font-body text-white/80 leading-relaxed space-y-6">
          {children}
        </div>

        <div className="mt-12 p-6 rounded-2xl bg-brand-surface border border-white/10 text-sm text-white/70">
          <p>
            <strong className="text-white">Contact:</strong> {STORE.name}, {STORE.address_line1},{" "}
            {STORE.address_line2}. Tel:{" "}
            <a className="text-brand-orange hover:underline" href={STORE.phone_tel}>
              {STORE.phone}
            </a>.
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
